import bnc from "bnc";

export const block = new bnc("standings-page");
